export const fcmPremission = async () => {

	return Notification.requestPermission().then(async (permission) => {

		if (permission !== "granted") return false;
		return true;

	});

};

export const fcmGetMessage = async (messaging, callBack) => {

	messaging.onMessage((payload) => callBack(payload));

};

export const fcmGetToken = async (messaging, device, callBack) => {

	const isGuaranted = await fcmPremission();
	if (!isGuaranted) {

		callBack(false);
		return;

	}

	try {

		const registrations = await navigator.serviceWorker.getRegistrations();
		const existingSW = registrations.find((reg) =>
			reg.active?.scriptURL.includes("firebase-messaging-sw.js"));

		if (existingSW) {

			// 🔁 Sudah terdaftar, langsung ambil token
			const token = await messaging.getToken({
				serviceWorkerRegistration: existingSW,
				vapidKey: process.env.NEXT_PUBLIC_VAPID_KEY,
			});

			// console.log("-Use Existing FCM Token-");

			callBack(token || false);

		} else {

			// 🆕 Belum ada, lakukan pendaftaran dan delay sebelum ambil token
			const serviceWorker = await navigator.serviceWorker.register(
				`/firebase-messaging-sw.js?device=${device}`,
			);

			// ⏱ Tunggu 1 detik sebelum ambil token
			setTimeout(async () => {

				try {

					const token = await messaging.getToken({
						serviceWorkerRegistration: serviceWorker,
						vapidKey: process.env.NEXT_PUBLIC_VAPID_KEY,
					});

					// console.log("-FCM Token Registered-");

					callBack(token || false);

				} catch (err) {

					callBack(false);

				}

			}, 1000);

		}

	} catch (error) {

		console.error("FCM token error:", error);
		callBack(false);

	}

};
